import { useTranslation } from "react-i18next";
import { BrandedFooter } from "./BrandedFooter";

interface WifiCheckPageProps {
  siteName: string;
  onYes: () => void;
  onNo: () => void;
}

export function WifiCheckPage({ siteName, onYes, onNo }: WifiCheckPageProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-md mx-auto px-4 py-8">
        <h1 className="text-xl font-semibold text-gray-800 mb-8">{siteName}</h1>

        <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6 shadow-sm text-center">
          <div className="text-4xl mb-4">📶</div>
          <p className="text-gray-800 font-semibold text-lg">{t("wifi_check_title")}</p>
        </div>

        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={onYes}
            className="w-full py-3 px-4 btn-primary rounded-xl font-semibold transition-colors"
          >
            ✓ {t("wifi_check_yes")}
          </button>
          <button
            type="button"
            onClick={onNo}
            className="w-full py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-300 transition-colors"
          >
            ✗ {t("wifi_check_no")}
          </button>
        </div>

        <BrandedFooter />
      </div>
    </div>
  );
}
